export default "__VITE_ASSET__RJ5yDeYh__"